import React, { useEffect, useState } from "react";
import "./LocalMunicipalCouncil.css";
import "../../../assets/fonts/Fonts.css";
import { Link } from "react-router-dom";
import { stateImages } from "../CoatOfArms";
import api from "../../../services/baseUrl";
export default function LocalMunicipalCouncil() {
  const [states, setStates] = useState([]);

  useEffect(() => {
    const fetchLibraries = async () => {
      try {
        const response = await api.get(
          "/api/egazette-documents/libraries/all",
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const filteredResponse = response.data.filter(
          (item) => item.orderId !== null
        );

        setStates(filteredResponse);
      } catch (error) {}
    };
    fetchLibraries();
  }, []);

  // const replaceSpacesWithNbsp = (text) => {
  //   if (!text || typeof text !== "string") {
  //     return text; // Return as-is if text is not a string or is null/undefined
  //   }
  //   return text.replace(/ /g, "\u00A0");
  // };

  return (
    <div className="">
      <div className="local-municipal-council-content">
        <div className="local-municipal-council-announcement">
          Access to up-to-date information on rules and regulations enacted by 
          <br /> local governing bodies such as local municipal councils on specific 
          <br /> matters within their respective jurisdictions.
        </div>
        {/* <div className="local-municipal-council-search">
          <Search />
        </div> */}
        <div
          className="local-municipal-council-state-gallery"
          style={{ padding: "35px" }}
        >
          {states.map((item, index) => (
            <Link key={index} to={`${item.id}`} className="gallery-item">
              <img
                src={stateImages[index]}
                alt={`${item.name} Logo`}
                className="gallery-image"
              />
              <p className="gallery-name">{item.displayName} </p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
